/*
 * @Description: 数据分析有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  分配线索数: '分配线索数',
  飞书: '飞书',
  图表: '图表',
  表格: '表格',
  数据概览: '数据概览',
  动态记录数: '动态记录数',
  外呼接通数: '外呼接通数',
  日程数: '日程数',
  线索总数: '线索总数',
  超2日待处理: '超2日待处理',
  走势图: '走势图',
  默认规则展示: '默认规则展示',
  按日展示: '按日展示',
  按周展示: '按周展示',
  按月展示: '按月展示',
  待处理线索数量: '待处理线索数量',
  状态分布: '状态分布',
  线索及时跟进率: '线索及时跟进率',
  客户发展阶段分布: '客户发展阶段分布',
  客户一级行业分布: '客户一级行业分布',
  客户二级行业分布: '客户二级行业分布',
  客户地域分布: '客户地域分布',
  客户规模分布: '客户规模分布',
  区域指标对比: '区域指标对比',
  个人指标对比: '个人指标对比',
  个人指标报表: '个人指标报表',
  客户行业分布: '客户行业分布',
  二级行业: '二级行业',
  排名: '排名',
  客户数: '客户数',
  占比: '占比',
  省份: '省份',
  城市: '城市'
};
